import { noop } from "lodash"
import { create } from "zustand"

import { IGameEquipWithAction } from "../../data/battle"
import { IGameItem, THistory } from "../../type"

interface GameModalStore {
    callBackpackModal: () => void
    callItemModal: (
        item: IGameItem,
        immediate?: boolean,
        cb?: () => void
    ) => void
    callGalleryModal: () => void
    callCraftModal: () => void
    callHistoryModal: (history?: THistory[]) => void
    callUseItemModal: (cb?: (key: string) => void) => void
    callShareModal: () => void
    callRollModal: () => void
    callRuleModal: () => void
    callAddressModal: () => void
    callEquipModal: (
        value: IGameEquipWithAction,
        immediate?: boolean,
        cb?: () => void
    ) => void
    callEffectModal: (key: string) => void
    callRestartModal: () => void
}

export const useGameModalStore = create<GameModalStore>((set) => ({
    callBackpackModal: noop,
    callItemModal: noop,
    callGalleryModal: noop,
    callCraftModal: noop,
    callHistoryModal: noop,
    callUseItemModal: noop,
    callShareModal: noop,
    callRollModal: noop,
    callRuleModal: noop,
    callAddressModal: noop,
    callEquipModal: noop,
    callEffectModal: noop,
    callRestartModal: noop,
}))

export const useGameBackpackModal = () =>
    useGameModalStore((state) => state.callBackpackModal)

export const useGameItemModal = () =>
    useGameModalStore((state) => state.callItemModal)

export const useGameGalleryModal = () =>
    useGameModalStore((state) => state.callGalleryModal)

export const useGameCraftModal = () =>
    useGameModalStore((state) => state.callCraftModal)

export const useGameHistoryModal = () =>
    useGameModalStore((state) => state.callHistoryModal)

export const useGameUseItemModal = () =>
    useGameModalStore((state) => state.callUseItemModal)

export const useGameShareModal = () =>
    useGameModalStore((state) => state.callShareModal)

export const useGameRollModal = () =>
    useGameModalStore((state) => state.callRollModal)

export const useGameRuleModal = () =>
    useGameModalStore((state) => state.callRuleModal)

export const useGameAddressModal = () =>
    useGameModalStore((state) => state.callAddressModal)

export const useGameEquipModal = () =>
    useGameModalStore((state) => state.callEquipModal)

export const useGameEffectModal = () =>
    useGameModalStore((state) => state.callEffectModal)

export const useGameRestartModal = () =>
    useGameModalStore((state) => state.callRestartModal)
